import { DesignerHeaderProps } from './Types'
import { observer } from 'mobx-react-lite'
import { Header } from './Header'
import { MobileDesignerTopBar } from 'blaze-components/MobileDesignerTopBar/MobileDesignerTopBar'
import { useRootStore } from 'stores/RootStore'
import Styles from './DesignerHeader.module.scss'

export const MobileDesignerHeader = observer(({ fileId }: DesignerHeaderProps) => {
  const { designStore } = useRootStore()

  return (
    <div onClick={() => designStore?.editor.updateInstanceState({ isFocused: true })}>
      <Header data-testid="designer-header" className={Styles.header}>
        <MobileDesignerTopBar fileId={fileId} />
      </Header>
    </div>
  )
})
